export enum UserRoles {
  PlantHR = 118,
  Contractor = 119,
  ER = 120,
  HRBP = 122
}